import { useCallback, useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';
import { IApiGetListScreensInStoreParam } from 'modules/store/interfaces/api';

const useGetAllPlaylistsInStore = (storeId: string) => {
  const dispatch = useAppDispatch();
  const playlistsInStore = storeSelectors.getAllPlaylistsInStore();

  const mutate = useCallback((params: IApiGetListScreensInStoreParam) => {
      dispatch(storeActions.getAllPlaylistsInStore.fetch({ ...params, storeId }));
    },
    [dispatch, storeId]
  );

  useEffect(() => {
    mutate({
      page: 1,
      size: 1000,
    });
  }, [mutate]);

  return {
    playlistsInStore,
    mutate,
  };
};

export default useGetAllPlaylistsInStore;
